import React from 'react';
import { motion } from 'framer-motion';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import './FAQ.css';

const FAQ = () => {
  const [openItem, setOpenItem] = React.useState(null);

  const toggleItem = (index) => {
    setOpenItem(openItem === index ? null : index);
  };

  const faqData = [
    {
      question: "What is Digital Fig?",
      answer: "Digital Fig is a creative and strategic collaboration; from seed to fruition - we build, grow, and support digital projects, products, and brands."
    },
    {
      question: "What kind of projects do you work on?",
      answer: "We work across digital media, e-commerce, design, content, and community-driven platforms. Every project is crafted with care and built to last."
    },
    {
      question: "What tools do you use to build sites?",
      answer: "Digital Fig employs top-tier software and platforms-ranging from Figma and Sketch for design, to WordPress, Webflow, or React-based frameworks for builds. We choose the best fit for your goals, performance needs, and budget."
    },
    {
      question: "Are Digital Fig websites SEO‑friendly?",
      answer: "Yes! Every site is built for performance and search success: Semantic HTML, clean code; Fast loading speeds; Mobile-first responsive design; Basic on-page SEO setup (meta tags, site speed optimization, sitemap)."
    },
    {
      question: "Who provides the content?",
      answer: "You're in full control. You own and supply the copy, images, content and media. Need help with ideas? Our expert copywriters and content strategists are available to help you finalise your project requirements."
    },
    {
      question: "Do I pay extra for hosting or SSL?",
      answer: "No extra charges! Hosting, SSL certificates, backups, and updates are included in your monthly bundle. No hidden costs!"
    },
    {
      question: "Do you outsource any work?",
      answer: "All core design and development is done in-house by our talented Digital Fig team. Occasionally, we engage trusted specialists for advanced integrations—always under our quality control."
    },
    {
      question: "How do you arrange client meetings?",
      answer: "Our clients are our priority. Meetings and client support are fully remote-friendly at a convenient time for you."
    },
    {
      question: "So what's the catch?",
      answer: "No hidden clauses or sneaky upsells. Our promise: transparent pricing, no lock-in contracts, and full creative ownership from day one."
    },
    {
      question: "Can I cancel anytime?",
      answer: "Yes - email us to cancel anytime. You are in control of your bundle!"
    }
  ];

  return (
    <section id="faq" className="faq section">
      <div className="container">
        <motion.div 
          className="section-title"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <h2>Frequently Asked Questions</h2>
          <p>Everything you need to know about Digital Fig</p>
        </motion.div>
        
        <div className="faq-container">
          {faqData.map((item, index) => (
            <motion.div 
              key={index}
              className={`faq-item ${openItem === index ? 'open' : ''}`}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
            >
              <button 
                className="faq-question" 
                onClick={() => toggleItem(index)}
                aria-expanded={openItem === index}
              >
                <span>{item.question}</span>
                <FontAwesomeIcon 
                  icon={faChevronDown} 
                  className={`faq-icon ${openItem === index ? 'rotated' : ''}`}
                />
              </button>
              <div className={`faq-answer ${openItem === index ? 'expanded' : ''}`}>
                <p>{item.answer}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;